/* 🤖 this file was generated by svg-to-ts */
export const matIconDensitySmall: {
  name: 'density-small';
  data: string;
} = {
  name: 'density-small',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 2h18v2H3zm0 18h18v2H3zm0-6h18v2H3zm0-6h18v2H3z"/></svg>`
};
